import React from 'react';
import { connect } from 'formik';

const connectToFormik = (Component) => {
  return connect(({ fieldProps: { onChange, ...fieldProps }, formik, ...props }) => {

    const handleChange = (value) => {
      formik.setValues({
        ...formik.values,
        [fieldProps.name]: value,
      });
    };

    return (
      <Component
        {...props}
        fieldProps={{
          onChange: handleChange,
          ...fieldProps,
        }}
      />
    );
  });
};

export default connectToFormik;
